import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { HOME_PAGE } from "constants/routes";
import "./ErrorPage.scss";

const ErrorPage: React.FC<{ onReset?: () => void }> = ({ onReset }) => {

  useEffect(() => {
    document.title = "Error - DAM";
    window.scrollTo(0, 0);
  }, []);

  const handleHomeClick = () => {
    if (onReset){
      onReset();
    }

  };

  return (
    <div className="error-page">
      <h1>Something went wrong</h1>
      <p>
        An unexpected error has occurred. Please try again later !
      </p>
      <p>
        If the problem persists, please contact support <Link
          to="mailto:DigitalAsset.support@thermofisher.com"
          target="_blank"
          rel="noreferrer">
          DigitalAsset.support@thermofisher.com
        </Link> with the details.
      </p>
      <p>
        Please click <Link className="home-link" to={HOME_PAGE} onClick={handleHomeClick}>home</Link> to return to the homepage.
      </p>

    </div>
  );
};

export default ErrorPage;